import { render } from "./BetaBanner.vue?vue&type=template&id=62016f60&scoped=true&ts=true"
import script from "./BetaBanner.vue?vue&type=script&lang=ts"
export * from "./BetaBanner.vue?vue&type=script&lang=ts"

import "./BetaBanner.vue?vue&type=style&index=0&id=62016f60&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62016f60"]])

export default __exports__